import { extend, $$, $ } from './HelperFunctions'

export class MainNavigation {
  constructor (selectors) {
    this.selectors = extend({
      mainNavigation: '[data-js-main-navigation]',
      menuToggle: '[aria-haspopup=true]',
      backButton: '[data-js-back-button]',
      navigationLevel: '[data-js-main-navigation-level]'
    }, selectors)
  }

  init () {
    this.initNavigation()
  }

  initNavigation () {
    const that = this
    const mainNavigation = $(that.selectors.mainNavigation)
    const menuToggles = $$(that.selectors.menuToggle, mainNavigation)
    const backButtons = $$(that.selectors.backButton, mainNavigation)

    if (menuToggles) {
      [].forEach.call(menuToggles, (menuToggle) => {
        menuToggle.addEventListener('click', function () {
          const expanded = this.getAttribute('aria-expanded')

          if (expanded === 'false') {
            // close all other menus
            for (const sibling of this.parentNode.closest(that.selectors.navigationLevel).children) {
              if (sibling !== this.parentNode) {
                const siblingButtons = sibling.querySelectorAll(that.selectors.menuToggle)
                siblingButtons.forEach(siblingButton => {
                  siblingButton.setAttribute('aria-expanded', false)
                })
              }
            }

            // only open this menu
            this.setAttribute('aria-expanded', true)
          } else {
            this.setAttribute('aria-expanded', false)
          }

          // check if mega menu is active
          document.addEventListener('keydown', function (event) {
            if ($(that.selectors.mainNavigation + ' > li > [aria-expanded=true]') && event.key === 'Escape') {
              [].forEach.call(menuToggles, (menuToggle) => {
                menuToggle.setAttribute('aria-expanded', false)
              }, false)
            }
          })
        }, false)
      })
    }

    if (backButtons) {
      backButtons.forEach(toggle => {
        toggle.addEventListener('click', function () {
          const controls = this.getAttribute('data-js-controls')
          this.parentNode
            .closest(that.selectors.mainNavigation)
            .querySelector('[aria-controls=' + controls + ']')
            .setAttribute('aria-expanded', false)
        }, false)
      }, false)
    }

    document.addEventListener('click', function (event) {
      if (event.target !== $(that.selectors.mainNavigation) &&
        event.target.parentNode.closest(that.selectors.mainNavigation) !==
        $(that.selectors.mainNavigation)) {
        [].forEach.call(menuToggles, (menuToggle) => {
          menuToggle.setAttribute('aria-expanded', false)
        }, false)
      }
    })
  }
}

export default MainNavigation
